import React, { useState, useRef, useEffect } from "react";
import Icon from "../Icons";

const CustomSelect = ({
  label,
  name,
  value,
  type,
  textSize="text-sm sm:text-base md:text-xl",
  border,
  bg = "bg-[#2E4051]",
  onChange,
  onBlur,
  error,
  options = [],
  py = 2,
}: any) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleOptionClick = (optionValue: any) => {
    onChange({ target: { name, value: optionValue } });
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selectedOption = options.find((opt: any) => opt.value === value);

  return (
    <div
      className={`flex flex-col w-full relative ${border}`}
      ref={dropdownRef}
    >
      {label !== "" && (
        <label className="block text-sm sm:text-base md:text-xl font-normal text-[#889DB2] mb-1 sm:mb-2">
          {label}
        </label>
      )}

      {/* Custom dropdown button */}
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        onBlur={onBlur}
        className={`flex items-center justify-between w-full px-3 py-${py}  rounded-md text-[#F4F5F7] ${bg} focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564] ${
          error ? "border-red-500" : ""
        }`}
      >
        <span
          className={`${
            selectedOption?.label ? `text-[#F4F5F7] ${textSize} font-semibold`  : "text-[#F4F5F7] opacity-50"
          } `}
        >
          {selectedOption?.label || "Enter..."}
        </span>
        {/* <svg
          className={`w-5 h-5 transition-transform ${
            isOpen ? "rotate-180" : ""
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg> */}
        <Icon name="ic-down" className="w-4 h-4 text-white" />
      </button>

      {/* Custom dropdown options */}
      {isOpen && (
        <div
          className={`py-1 absolute top-full left-0 right-0 z-50 mt-1 max-h-64 overflow-auto bg-[#222F3C] border border-[#374B5E] rounded-md shadow-lg scrollbar-hide`}
        >
          {options.map((option: any) => (
            <div
              key={option.value}
              onClick={() => handleOptionClick(option.value)}
              className={`${textSize} px-3 py-2 cursor-pointer transition-colors ${
                value === option.value
                  ? "bg-[#008564] text-white"
                  : "text-[#E7EEF9] hover:bg-[#2E4051]"
              }`}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}

      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
    </div>
  );
};

export default CustomSelect;
